import React from "react";
import { Link } from "react-router-dom";
import { Eyebrow } from "../components/Primitives";
import AppShell from "../components/AppShell";

export default function Privacy() {
    return (
        <AppShell>
            <div className="flex-1 flex flex-col bg-cream" data-testid="privacy-screen">
                <div className="px-6 pt-6 pb-3 flex items-center justify-between border-b border-burgundy/10">
                    <Link to="/" data-testid="privacy-back-link" className="tap-target text-[11px] tracking-[0.28em] uppercase text-ink-muted hover:text-burgundy">
                        ← Back
                    </Link>
                    <span className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Legal</span>
                    <span className="w-8" />
                </div>

                <article className="flex-1 overflow-y-auto px-7 py-8 max-w-2xl mx-auto w-full">
                    <Eyebrow>Privacy</Eyebrow>
                    <h1 className="mt-2 font-display text-4xl text-burgundy leading-[1.1]">
                        <span className="italic">Privacy</span> policy
                    </h1>
                    <p className="mt-3 text-[10px] tracking-[0.32em] uppercase text-ink-light" data-testid="privacy-updated">
                        Last updated · February 2026
                    </p>

                    <section className="mt-8 space-y-6 text-sm text-ink leading-relaxed">
                        <h2 className="font-display italic text-2xl text-burgundy">Data Privacy &amp; AI Use</h2>

                        <p>
                            Ever After is committed to protecting your privacy and complying with applicable U.S. data protection laws, including the California Consumer Privacy Act (CCPA) and other state privacy laws where applicable.
                        </p>

                        <div>
                            <p className="font-semibold text-burgundy">Under these laws, you have the right to:</p>
                            <ul className="mt-3 space-y-2 pl-1">
                                <li className="flex gap-2"><span className="text-gold-deep">·</span><span>Know what categories of personal data we collect, and the purposes for which it is used.</span></li>
                                <li className="flex gap-2"><span className="text-gold-deep">·</span><span>Request access to your personal data and request that it be deleted, subject to certain exceptions.</span></li>
                                <li className="flex gap-2"><span className="text-gold-deep">·</span><span>Opt out of the sale or sharing of your personal data.</span></li>
                                <li className="flex gap-2"><span className="text-gold-deep">·</span><span>Correct inaccurate personal data that we maintain.</span></li>
                                <li className="flex gap-2"><span className="text-gold-deep">·</span><span>Not be discriminated against for exercising your privacy rights.</span></li>
                            </ul>
                        </div>

                        <div className="editorial-rule my-2" />

                        <p>
                            Ever After uses artificial intelligence (AI) to provide personalized matchmaking, dating insights, and safety enhancements. Our AI systems are designed with transparency and fairness in mind, and we do not make fully automated decisions that have a legal or similarly significant effect without human oversight.
                        </p>

                        <p>
                            We continuously monitor and improve our AI algorithms to ensure ethical use, compliance with AI regulatory frameworks, and prevention of algorithmic bias.
                        </p>

                        <div className="mt-6 p-5 bg-cream-soft border border-burgundy/15">
                            <p className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Contact</p>
                            <p className="mt-2 text-sm text-ink">
                                For questions or concerns related to your data or AI use, please contact our Privacy Officer at{" "}
                                <a
                                    data-testid="privacy-contact-email"
                                    href="mailto:info@youreverafter.com"
                                    className="text-burgundy underline underline-offset-4"
                                >
                                    info@youreverafter.com
                                </a>.
                            </p>
                        </div>
                    </section>

                    <footer className="mt-12 pt-6 border-t border-burgundy/15 text-center text-[10px] tracking-[0.32em] uppercase text-ink-light">
                        <Link to="/" className="hover:text-burgundy" data-testid="privacy-home-link">
                            Ever After · youreverafter.com
                        </Link>
                    </footer>
                </article>
            </div>
        </AppShell>
    );
}
